import { MembershipProfileTag as MembershipProfileTagModel } from '@models/membership/MembershipProfileTag'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileTagById } from '@store/membership/MembershipProfileTagReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'

type Props = SBModelComponent<MembershipProfileTagModel> & {
  size?: AvatarProps['size']
}

const MembershipProfileTagAvatar: FC<Props> = ({ id, model }) => {
  const item = model
    ? model
    : useAppSelector(selectMembershipProfileTagById(id!))

  if (!item) {
    return <></>
  }
  return <Tag color={item.color}>{item.name}</Tag>
}

type MembershipProfileTagAvatarType = {
  Avatar: typeof MembershipProfileTagAvatar
}

export { MembershipProfileTagAvatar, type MembershipProfileTagAvatarType }
